import { useEffect } from 'react';
import axios from 'axios';
import { getApiUrl, API_ENDPOINTS } from '../config/api';

const VisitTracker = ({ page = 'home' }) => {


  useEffect(() => {
    const trackVisit = async () => {
      try {
        // Only track once per session per page
        const sessionKey = `visited_${page}`;
        if (sessionStorage.getItem(sessionKey)) {
          return;
        }

        await axios.post(getApiUrl('/api/track-visit'), {
          page,
          userAgent: navigator.userAgent,
          referrer: document.referrer || 'direct'
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        // Mark as tracked for this session
        sessionStorage.setItem(sessionKey, 'true');
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Visit tracking failed:', error.message);
      }
    };

    // Track after a short delay to ensure page is loaded
    const timer = setTimeout(trackVisit, 1000);
    
    return () => clearTimeout(timer);
  }, [page]);

  // This component doesn't render anything
  return null;
};

export default VisitTracker; 